import React from 'react';

// Minimal markdown-to-JSX renderer for the EULA document. Only supports the
// handful of constructs eula.md actually uses (h1/h2, bold, bullet lists,
// paragraphs) — not a general-purpose markdown parser.

function renderInline(text, keyPrefix) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={`${keyPrefix}-${i}`}>{part.slice(2, -2)}</strong>;
    }
    return <span key={`${keyPrefix}-${i}`}>{part}</span>;
  });
}

export function parseEulaMarkdown(markdown) {
  const lines = markdown.replace(/\r\n/g, '\n').split('\n');
  const blocks = [];
  let listItems = [];
  let paragraph = [];

  const flushList = () => {
    if (listItems.length === 0) return;
    const idx = blocks.length;
    blocks.push(
      <ul key={`ul-${idx}`}>
        {listItems.map((item, i) => (
          <li key={i}>{renderInline(item, `li-${idx}-${i}`)}</li>
        ))}
      </ul>,
    );
    listItems = [];
  };

  const flushParagraph = () => {
    if (paragraph.length === 0) return;
    const idx = blocks.length;
    const text = paragraph.join(' ');
    blocks.push(<p key={`p-${idx}`}>{renderInline(text, `p-${idx}`)}</p>);
    paragraph = [];
  };

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (line === '') {
      flushParagraph();
      flushList();
      continue;
    }
    if (line.startsWith('# ')) {
      flushParagraph();
      flushList();
      blocks.push(<h1 key={`h1-${blocks.length}`}>{line.slice(2)}</h1>);
      continue;
    }
    if (line.startsWith('## ')) {
      flushParagraph();
      flushList();
      blocks.push(<h2 key={`h2-${blocks.length}`}>{line.slice(3)}</h2>);
      continue;
    }
    if (line.startsWith('- ')) {
      flushParagraph();
      listItems.push(line.slice(2));
      continue;
    }
    flushList();
    paragraph.push(line);
  }

  flushParagraph();
  flushList();

  return blocks;
}
